import type { JSX } from "solid-js";

import styles from "~/components/CircleProgress.module.scss";

interface CircleProgressProps {
  readonly size: JSX.CSSProperties["height"];
  readonly class?: string;
  readonly progress: number;
}

export default function CircleProgress(props: CircleProgressProps) {
  const progress = () => Math.min(1, Math.max(0, props.progress));

  return (
    <div
      classList={{ [styles.wrapper]: true, [props.class ?? ""]: true }}
      style={{
        "--size": props.size,
        "--progress": `${(progress() * 100).toString()}%`,
        "--remaining-progress": `${((1 - progress()) * 100).toString()}%`,
      }}
    >
      <div class={styles["progress-outer"]} aria-hidden="true" />
      <div class={styles["progress-inner"]} aria-hidden="true" />
      <progress value={progress()} />
    </div>
  );
}
